import { getMerchant, saveMerchant } from '@/services/merchants';
import { useShopsStore } from '@/stores/shops';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { MerchantServiceApiMerchantServiceUpdateRequest, ModelMerchantResponse } from '@layup/api-sdk';

export const useMerchantStore = defineStore('merchants', {
  state: () => {
    const merchant = ref<ModelMerchantResponse>({});
    const activeMerchantId = ref('');

    return {
      merchant,
      activeMerchantId,
    };
  },
  actions: {
    async onChangeMerchant(merchantId: string) {
      this.activeMerchantId = merchantId;
      const merchantResponse = await getMerchant(merchantId);
      this.merchant = merchantResponse;
    },
    setMerchant(merchantData: ModelMerchantResponse) {
      this.merchant = merchantData;
    },
    async saveMerchantSettings(params: MerchantServiceApiMerchantServiceUpdateRequest): Promise<ModelMerchantResponse> {
      const response = await saveMerchant(params);
      this.merchant = { ...this.merchant, ...response };
      useShopsStore().lastFetchedAt = null;

      return response;
    },
    onResetMerchant() {
      this.activeMerchantId = '';
      this.merchant = {};
    },
    reset() {
      this.$reset();
    },
  },
  persist: true,
});
